import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/setting`;

export const saveSetting = async (setting) => {
  try {
    const response = await api.post(API_URL, setting);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du paramètre :', error);
    handleHttpError(error, "Échec de l'enregistrement du paramètre.");
    throw error;
  }
};

export const deleteUserObjective = async (settingId, email) => {
  const url = `${API_URL}/${settingId}/${email}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error('Erreur lors de la suppression de l’objectif :', error);
    handleHttpError(error, "Échec de la suppression de l’objectif.");
    throw error;
  }
};

export const updateSetting = async (settingId, setting) => {
  const url = `${API_URL}/${settingId}`;
  try {
    const response = await api.put(url, setting);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du paramètre :', error);
    handleHttpError(error, "Échec de la mise à jour du paramètre.");
    throw error;
  }
};

export const getAllSetting = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des paramètres :', error);
    handleHttpError(error, "Impossible de récupérer les paramètres.");
    throw error;
  }
};

export const getSetting = async () => {
  const url = `${API_URL}/one`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du paramètre :', error);
    handleHttpError(error, "Impossible de récupérer le paramètre.");
    throw error;
  }
};


export const updateObjectiveDelay = async (delay) => {
  const url = `${API_URL}/objective-delay/${delay}`;
  
  try {
    const response = await api.put(url);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du délai des objectifs :", error);
    handleHttpError(error, "Échec de la mise à jour du délai des objectifs.");
    throw error;
  }
};

export const updateEvaluationDelay = async (delay) => {
  const url = `${API_URL}/evaluation-delay/${delay}`;
  
  try {
    const response = await api.put(url);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du délai des évaluations :", error);
    handleHttpError(error, "Échec de la mise à jour du délai des évaluations.");
    throw error;
  }
};

export const getObjectiveDelay = async () => {
  try {
    const response = await api.get(`${API_URL}/objective-delay`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du délai des objectifs :', error);
    handleHttpError(error, "Impossible de récupérer le délai des objectifs.");
    throw error;
  }
};

export const getEvaluationDelay = async () => {
  try {
    const response = await api.get(`${API_URL}/evaluation-delay`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du délai des évaluations :', error);
    handleHttpError(error, "Impossible de récupérer le délai des évaluations.");
    throw error;
  }
};
